import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import MCExportButton from "./MCExportButton";

const EXPORT_TARGETS = [
  { label: "Export Users", endpoint: "/master-control/export/users", filename: "users.csv", capability: "canViewMasterControl" },
  { label: "Export Organizations", endpoint: "/master-control/export/organizations", filename: "organizations.csv", capability: "canViewMasterControl" },
  { label: "Export Agent Usage", endpoint: "/master-control/export/agent-usage", filename: "agent_usage.csv", capability: "canViewMasterControl" },
  { label: "Export Error Logs", endpoint: "/master-control/export/errors", filename: "errors.json", capability: "canViewMasterControl" },
  { label: "Export Audit Logs", endpoint: "/master-control/export/audit-logs", filename: "audit_logs.json", capability: "canViewMasterControl" },
];

export function MCExportTools() {
  return (
    <Card className="rounded-2xl border border-border bg-background/60 shadow-none">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-foreground">Exports</CardTitle>
        <p className="text-sm text-muted-foreground">Download system datasets for offline audits.</p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
          {EXPORT_TARGETS.map((target) => (
            <MCExportButton key={target.endpoint} {...target} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default MCExportTools;
